import './2gether/style';
import FormStructure from './2gether/form_structure';

export default FormStructure;